export default __webpack_public_path__ + "static/media/team-photo5.73edb0a9.jpg";